import { ProcessingState } from "./ProcessingState";
import { GET_PROCESSING_CONFIG_SUCCESS, ProcessingActionsType } from "./SharedProcessingActions";

const initialState: ProcessingState = {
    selectedIndicator: null,
    selectedProcessing: null,
    config: null,
}

export const sharedProcessingReducer = (state: ProcessingState = initialState, actions: ProcessingActionsType): ProcessingState => {
    switch (actions.type) {
        case GET_PROCESSING_CONFIG_SUCCESS:
            return {
                ...state,
                config: actions.payload,
            }

        default:
            return state
    }
}